<template>
  <div>
    <!--      start edit mode -->
    <v-dialog v-model="editModal" max-width="700px" transition="dialog-bottom-transition">
      <v-card class="pb-5">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>ویرایش</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark icon @click="editModal = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div class="row mx-auto">
          <div class="col-md-6 mt-5">
            <v-text-field v-model.number="updatedData.per" clear-icon="mdi-close-circle-outline" clearable dense
                          label="تعداد آگهی جدید" max="10" min="1"
                          oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; else if(Number(this.value) < Number(this.min)) this.value = this.min;"
                          outlined prepend-inner-icon="fa fa-pencil-alt" type="number"
                          @keypress="allowOnlyNumbers($event)">

            </v-text-field>
          </div>
          <div class="col-md-6 mt-5">
            <v-text-field v-model.number="updatedData.count" clear-icon="mdi-close-circle-outline" clearable dense
                          label="تعداد آگهی من" max="10" min="1"
                          oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; else if(Number(this.value) < Number(this.min)) this.value = this.min;"
                          outlined prepend-inner-icon="fa fa-pencil-alt" type="number"
                          @keypress="allowOnlyNumbers($event)">
            </v-text-field>
          </div>
          <v-btn class="text-white submit-btn float-left mr-5 "
                 @click="updateAds(updatedData.id)">
            <span class="material-icons">save</span>
            ثبت
          </v-btn>
        </div>

      </v-card>
    </v-dialog>
    <!--      end edit mode -->

    <!--      start auth mode -->
    <v-dialog v-model="authModal" max-width="1200px" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar v-if="authModal" color="primary">
          <v-toolbar-title class="text-white">آگهی های من</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark icon @click="authModal = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-row v-if="authResult.length > 0" class="p-4">
          <v-col v-for="(item,index) in authResult"
                 class="col-md-4">
            <v-card :key="item.token" :color="mine.indexOf(item.token) > -1? 'red darken-3' : '#191179' "
                    class="text-white" dark elevation="4" max-height="400">
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title style="font-size: 9pt;font-weight: bold" v-text="item.place"/>
                  <v-card-subtitle v-text="item.title"></v-card-subtitle>
                  <div class="row px-2">
                    <v-card-subtitle v-text="item.price"></v-card-subtitle>
                    <v-card-subtitle v-text="item.data"></v-card-subtitle>
                  </div>
                </div>
                <v-avatar class="ma-3" size="115">
                  <v-img :src="item.image ? item.image : require('@/assets/img/rblandNotext.webp')"></v-img>
                </v-avatar>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <div v-else class="col-md-12">
          <p class="p-8 text-center text-danger">متاسفانه آگهی ای برای شما یافت نشد!</p>
        </div>
      </v-card>
    </v-dialog>
    <!--      end edit mode -->

    <!--      start adsList mode -->
    <v-dialog v-if="adsModal" v-model="adsModal" max-width="1200px" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title> لیست آگهی های من</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark icon @click="adsModal = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <related-ads v-if="adsModal" :Token="adsList"></related-ads>
      </v-card>
    </v-dialog>
    <!--      end edit mode -->

    <div class="col-md-12 p-0 mt-5 pt-5 mx-auto" style="border: none!important;">
      <div class="mt-5 pt-5">
        <v-card :loading="loading" class="p-3 pt-0">
          <terminal-table v-if="isMobile" :currentPage="datas.current_page"
                          :datas="datas" :getData="getDataForTable" :headers="columns"
                          :options="tableProps"
                          :pageCount="datas.last_page" :perPage="datas.per_page" class="col-12"></terminal-table>

          <data-table v-else :columns="columns" :data="datas" :debounce-delay="3000" :orderBy="tableProps.column"
                      :orderDir="tableProps.dir" :pagination="paginate" :per-page="[10, 25, 50, 100, 500]"
                      :translate="translate"
                      class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
                      @on-table-props-changed="reloadTable">
            <template slot="filters" slot-scope="{ tableFilters, perPage }">
              <filters-table v-model="searchBox"
                             @getInfo="(val)=>{ if (val) tableProps.search = searchBox.search }"/>
            </template>
          </data-table>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import button from "@/view/pages/button";
import {dataTableProps} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import createTarefe from "@/view/pages/tarefe/createTarefe";
import RelatedAds from "@/view/pages/ladder/relatedAds";
import {debounce} from "../../../custom";
import FiltersTable from "@/components/Table/filtersTable";

const moment = require('moment')

export default {
  name: "showTarefeList",

  components: {FiltersTable, RelatedAds, TitleRibbon, button, dataTableProps, createTarefe},

  data() {
    return {
      tarafeName: "",
      authModal: false,
      adsModal: false,
      editModal: false,
      loading: false,
      datas: {},
      mine: [],
      translate: dataTableProps.translate,
      paginate: dataTableProps.pagination,
      tableProps: dataTableProps.tableProps,
      url: `${url}/admin/monitoring/smart`,
      selectedNumber: [],
      dataId: '',
      adsList: '',
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.datas.current_page - 1;
            row = row * this.datas.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'کاربر',
          name: 'user',
          primary: true,
          transform(val) {
            return val.data.user.name + ' ' + val.data.user.lastName
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'نوع آگهی',
          primary: true,
          name: 'type',
          transform: (val) => {
            const type = {
              null: '',
              advertise: 'هوشمند',
              minute: 'تدریجی'
            };
            const kind = {
              default: 'ارسال آگهی',
              market: 'نردبان فروشگاهی',
              service: 'نردبان متخصص',
              normal: 'نردبان',
              new: 'تازه های دیوار'
            }
            return kind[val.data.kind] + ' ' + type[val.data.type];
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'تعداد آگهی جدید',
          name: 'per',
          transform: (val) => {
            return val.data.per && val.data.type === 'advertise' ? val.data.per : '-';
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'تعداد آگهی های من',
          name: 'count',
          transform: (val) => {
            return val.data.count ? val.data.count : '-';
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'فاصله زمانی',
          name: 'per_min',
          transform: (val) => {
            return val.data.per && val.data.type === 'minute' ? val.data.per : '-'
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'آخرین فعالیت',
          name: 'last_activity',
          transform: (val) => {
            return val.data.last_activity ? val.data.last_activity : '-'
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'شروع فعالیت',
          name: 'start_at_p',
          transform: ({data}) => {
            let isAfter = moment().isAfter(data.start_at)
            let isPast = moment().isBefore(data.expire_at)

            return data.start_at_p
              ? `<span class="text-wrap badge badge-${isAfter && !isPast ? 'danger' : isAfter ? 'success' : 'danger'}">${data.start_at_p}</span>`
              : '-'
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'پایان فعالیت',
          name: 'expire_at_p',
          transform: ({data}) => {
            let isPast = moment().isBefore(data.expire_at)

            return data.expire_at_p
              ? `<span class="text-wrap badge badge-${!isPast ? 'danger' : 'success'}">${data.expire_at_p}</span>`
              : 'ندارد'
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'آگهی اعمال شده',
          name: 'assessed',
          transform: (val) => {
            return val.data.assessed ? val.data.assessed : '0'
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'وضعیت آگهی',
          name: 'deleted_at',
          transform: (val) => {
            let del = (element) => {
              if (val.data.deleted_at == null)
                this.$modal.yesNo('تایید غیرفعال کردن', 'آیا از غیرفعال کردن این آگهی اطمینان دارید؟', "neg", '').then((value => {
                  if (value === true) {
                    $.ajax({
                      url: `${url}/admin/monitoring/smart/${val.data.id}`,
                      fn: del,
                      type: 'DELETE',
                      headers: {
                        'Authorization': Token,
                        ACCEPT: 'application/json',
                      },
                      msg: true,
                      success: (res) => {
                        $(element.target).unbind();
                        this.loading = true;
                        this.reloadTable();
                      }
                    })
                  }
                }))
            };
            if (val.data.deleted_at != null) {
              return `<span class="badge badge-${val.data.deleted_at == null ? 'success' : 'danger'}" id="${val.data.id}">${val.data.deleted_at !== null ? 'غیرفعال' : 'فعال'}</span>`;
            } else
              $(document).on('click', `#${val.data.id}`, del);
            return `<span class="badge cursor-pointer badge-${val.data.deleted_at == null ? 'success' : 'danger'}" id="${val.data.id}">${val.data.deleted_at !== null ? 'غیرفعال' : 'فعال'}</span>`;
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'مدیریت',
          name: 'action',
          component: button,
          handler: this.actions,
          event: "actions",
          meta: {
            permission_prefix: 'notification_',
            buttons: [
              {
                name: 'edit',
                label: 'ویرایش',
                icon: 'pencil-alt',
                class: 'btn-outline-warning',
                action: this.actions,
                status: 'smarts_update',
                condition: this.buttonsCondition
              },
              {
                name: 'auth',
                label: 'اعتبار سنجی',
                icon: 'recycle',
                class: 'btn-outline-info',
                action: this.actions,
                status: 'admin_number_pack_destroy',
                condition: this.buttonsCondition
              },
              {
                name: 'adsList',
                label: 'لیست آگهی ها',
                icon: 'list',
                class: 'btn-outline-primary',
                action: this.actions,
                status: 'smarts_list',
                condition: () => {
                  return true;
                }
              },
            ]
          }
        }
      ],
      updatedData: [],
      authResult: [],
      searchBox: {
        search: '',
        length: 10
      },
    }
  },

  mounted() {
    this.tableProps = {
      search: '',
      length: 10,
      column: 'id',
      dir: 'desc',
      page: 1,
    };
    this.getDataForTable(this.url);
    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    });
  },

  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getDataForTable(this.url);
          return true
        case 'sm':
          this.getDataForTable(this.url);
          return true
        case 'md':
          this.getDataForTable(this.url);
          return false
        case 'lg':
          this.getDataForTable(this.url);
          return false
        case 'xl':
          this.getDataForTable(this.url);
          return false
      }
    },
  },

  watch: {
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true
    }

  },

  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true;
      $.ajax({
        url: url,
        fn: this.getDataForTable,
        type: 'GET',
        data: Object.assign({}, query, {search: this.tableProps.search, length: this.searchBox.length}),
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.datas = data.data;
          vm.loading = false
        }
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 700);
    },
    updateAds: function (id) {
      $.ajax({
        url: `${url}/smarts/${id}`,
        fn: this.updateAds,
        params: [id],
        type: 'PUT',
        data: {
          per: this.updatedData.per,
          count: this.updatedData.count
        },
        headers: {
          'Authorization': Token,
          ACCEPT: 'application/json',
        },
        msg: true,
        success: (res) => {
          this.editModal = false;
          this.reloadTable();

        }
      })
    },
    actions(data, type) {
      const vm = this;
      if (type === 'edit') {
        vm.editModal = true;
        $.ajax({
          url: `${url}/smarts/${data.id}`,
          type: 'GET',
          fn: this.actions,
          params: [data, type],
          headers: {
            "ACCEPT": "application/json",
            "Authorization": Token
          },
          success: (data) => {
            this.updatedData = data.data
          }
        })
      } else if (type === 'adsList') {
        if (data.kind !== 'default') {
          this.adsModal = true;
          this.adsList = data.id;
        } else this.$modal.error('شما قادر به مشاهده لیست آگهی ها نیستید!')
      } else if (type === 'auth') {
        if (data.type !== "minute") {
          this.authModal = true;
          $.ajax({
            url: `${url}/advertise/tokens`,
            type: 'GET',
            fn: this.actions,
            params: [data, type],
            headers: {
              "ACCEPT": "application/json",
              "Authorization": Token
            },
            success: (data) => {
              this.mine = data.data
            }
          });
          $.ajax({
            url: `${url}/divar/search`,
            type: 'POSt',
            data: data.search_payload,
            fn: this.actions,
            params: [data, type],
            headers: {
              "ACCEPT": "application/json",
              "Authorization": Token
            },
            success: (data) => {
              this.authResult = data.data
            }
          })
        } else this.$modal.error('شما قادر به اعتبار سنجی نیستید!')
      }
    },
    allowOnlyNumbers(value) {
      if (typeof Number(value.key) !== 'string') {
        let allowedKeys = [8, 46, 38, 40, 37, 39];
        const keypressed = value.which || value.keyCode;
        if (/[^0-9\s]+/.test(value.key)) {
          if (allowedKeys.every(e => e !== keypressed)) {
            value.preventDefault();
          }
        } else return true
      }
    },
  },
}
</script>

<style scoped>

</style>